import { digger } from '@cbre/digger';
import { NavigationRouteFunctionPPT } from '../../../models/template.model';

function propertyRouteFunction({ data }) {
  const entityRecord = Array.isArray(data) ? data[0] : data;
  return ['/records', 'property', digger(entityRecord, 'entity.id'), 'edit'];
}

function availabilityRouteFunction({ data }) {
  const entityRecord = Array.isArray(data) ? data[0] : data;
  return ['/records', 'availability', digger(entityRecord, 'entity.id'), 'edit'];
}

function saleRouteFunction({ data }) {
  const entityRecord = Array.isArray(data) ? data[0] : data;
  return ['/records', 'sale', digger(entityRecord, 'entity.id'), 'edit'];
}

function leaseRouteFunction({ data }) {
  const entityRecord = Array.isArray(data) ? data[0] : data;
  return ['/records', 'lease', digger(entityRecord, 'entity.id'), 'edit'];
}

function timRouteFunction({ data }) {
  const entityRecord = Array.isArray(data) ? data[0] : data;
  return ['/records', 'tim', digger(entityRecord, 'entity.id'), 'edit'];
}

export const PROPERTY_ROUTE_FN: NavigationRouteFunctionPPT = propertyRouteFunction;
export const AVAILABILITY_ROUTE_FN: NavigationRouteFunctionPPT = availabilityRouteFunction;
export const SALE_ROUTE_FN: NavigationRouteFunctionPPT = saleRouteFunction;
export const LEASE_ROUTE_FN: NavigationRouteFunctionPPT = leaseRouteFunction;
export const TIM_ROUTE_FN: NavigationRouteFunctionPPT = timRouteFunction;
